import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Toolbar, Typography, Tooltip, ToggleButton, Box, TextField, IconButton } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import ClearIcon from '@mui/icons-material/Clear';
import Container from './styles/Container';
import ToolbarBox from './styles/ToolbarBox';
import ErrorsBox from './styles/ErrorBox';

export default function EnhancedTableToolbar({
  allErrorsLength,
  showReordering,
  setShowReordering,
  onChangeSearchOrder,
  searchOrder,
}) {
  const [searchValue, setSearchValue] = React.useState(searchOrder || '');

  useEffect(() => {
    setSearchValue(searchOrder);
  }, [searchOrder]);

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    if (e.target.value.length > 2) onChangeSearchOrder(e.target.value);
    else onChangeSearchOrder('');
  };

  const handleClearSearch = () => {
    setSearchValue('');
    onChangeSearchOrder('');
  };

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Container>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <Typography variant="subtitle1" id="tableTitle" component="div">
            Доставка
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Поиск"
              value={searchValue}
              onChange={handleSearchChange}
              sx={{ width: 240 }}
            />
            {searchValue && (
              <IconButton size="small" onClick={handleClearSearch}>
                <ClearIcon color="primary" />
              </IconButton>
            )}
          </Box>
        </Box>
        <ToolbarBox>
          {allErrorsLength ? (
            <ErrorsBox>
              <ReportProblemIcon sx={{ color: 'red' }} />
              <Typography variant="subtitle1" component="p" sx={{ color: 'red' }}>
                {allErrorsLength}{' '}
                {allErrorsLength === 0
                  ? 'Предупреждений'
                  : allErrorsLength <= 4
                    ? 'Предупреждения'
                    : allErrorsLength >= 5
                      ? 'Предупреждений'
                      : 'Предупреждений'}
              </Typography>
            </ErrorsBox>
          ) : null}
        </ToolbarBox>
        <Tooltip title="Изменение порядка вручную" placement="top">
          <ToggleButton
            size="small"
            selected={showReordering}
            value=""
            onChange={() => setShowReordering(!showReordering)}
          >
            <ImportExportIcon color="primary" sx={{ rotate: '90deg' }} />
          </ToggleButton>
        </Tooltip>
      </Container>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  allErrorsLength: PropTypes.number.isRequired,
  showReordering: PropTypes.bool.isRequired,
  setShowReordering: PropTypes.func.isRequired,
  onChangeSearchOrder: PropTypes.func.isRequired,
  searchOrder: PropTypes.string.isRequired,
};
